import { useMutation } from "react-query";
import { getProducerCodeByCarrierProducerCodeId } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

export const useGetProducerCodeForEdit = () => {
  return useMutation(getProducerCodeByCarrierProducerCodeId);
};
